import { DateTime, Info, Settings } from "luxon";

Settings.defaultLocale = "en-US";
Settings.defaultWeekSettings = {
	firstDay: 7, // Sunday (Mon=1 ... Sun=7)
	minimalDays: Info.getMinimumDaysInFirstWeek(),
	weekend: Info.getWeekendWeekdays(),
};

// Save original method
const originalStartOf = DateTime.prototype.startOf;

// Override to always use useLocaleWeeks: true for week unit
DateTime.prototype.startOf = function (unit: any, opts?: any) {
	if (unit === "week") {
		return originalStartOf.call(this, unit, { ...opts, useLocaleWeeks: true });
	}
	return originalStartOf.call(this, unit, opts);
};

// ---- weekDay override: 1..7  ->  0..6 ----
// biome-ignore lint/style/noNonNullAssertion: We know it's there
const weekDayDescriptor = Object.getOwnPropertyDescriptor(DateTime.prototype, "weekday")!;

/**
 * It's a custom property that we define in luxon-augment.d.ts
 */
Object.defineProperty(DateTime.prototype, "weekdayISO", {
	get() {
		// biome-ignore lint/style/noNonNullAssertion: We know it's there
		const original = weekDayDescriptor.get!.call(this) as number; // 1..7
		return original % 7; // 0..6 (Sunday -> 0)
	},
});
